export default __webpack_public_path__ + "static/media/logo-login.f15a1731.svg";